module.exports = __webpack_public_path__ + "img/1 2.c81f22f0.png";